<template>
<m-pageframe
    title="RedChirp Billing"
>
<v-container
    fluid
    style="padding-left: 30px; padding-right: 30px"
>
    
    <m-invoice-period-selector
        v-model="selected_month"
        v-on:input="onChangeInvoiceMonth"
    />

    <v-row>
        <v-col
            style="max-width: 150px"
        >
            <v-select
                label="Batch"
                v-model="batch"
                :items="batch_choices"
                v-on:change="onChangeBatch"
            />
        </v-col>
        <v-col
            style="max-width: 200px"
        >
            <v-select
                label="Payment Method"
                v-model="payment_method"
                :items="$rc.enumChoices('red_chirp_payment_method',true)"
                v-on:change="doUpdate"
            />
        </v-col>

        <v-col
            style="max-width: 300px"
        >
            <v-select
                label="Last Invoice"
                v-model="last_invoice"
                :items="last_invoice_choices"
                v-on:change="doUpdate"
            />
        </v-col>
        

        <v-col>
            <v-text-field
                autocomplete="off"
                label="Search"
                prepend-icon="mdi-magnify"
                v-model="full_text"
                v-on:input="update"
            >
                <v-menu
                    bottom
                    offset-y
                    slot="append-outer"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                    </template>
            
                    <v-list>
                        <v-list-item
                            v-on:click="doUpdate()"
                        >
                            <v-list-item-title>Refresh</v-list-item-title>
                        </v-list-item>

                        <v-divider/>

                        <v-list-item
                            v-on:click="onClickCreateMissingInvoices()"
                        >
                            <v-list-item-title>Create lines for any missing organizations</v-list-item-title>
                        </v-list-item>

                         <v-divider/>

                        <v-list-item
                            v-on:click="onClickExcelExport()"
                        >
                            <v-list-item-title>Export to excel...</v-list-item-title>
                        </v-list-item>

                        
                    </v-list>
                </v-menu> 
            </v-text-field>
        </v-col>
    </v-row>
   
    <div
        style="display: flex; margin-bottom: 15px"
    >
        <v-chip
            v-if="selected.length == 0"
        >
            No invoices selected
        </v-chip>

        <div
            style="flex-grow: 1"
        >
            <v-chip
                v-for="(item, index) in selected"
                :key="'sc_'+index"
                style="margin-right: 5px"
                close
                v-on:click:close="onClickCloseSelectedChip(item)"
            >
                {{item.text}}
            </v-chip>
        </div>
        <div>
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickSelectAll()"
                >
                    <v-list-item-title>Select all in current search</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickClearSelection()"
                >
                    <v-list-item-title>Clear selected</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickUpdateInvoicesBatch()"
                >
                    <v-list-item-title>Create / update invoices...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickCollectBatch()"
                >
                    <v-list-item-title>Stripe auto collect...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickSendEmailSelected()"
                >
                    <v-list-item-title>Email invoices...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickSetCollectionState()"
                >
                    <v-list-item-title>Manually set collection state...</v-list-item-title>
                </v-list-item>

                 <v-list-item
                    v-on:click="onClickSetRecevied()"
                >
                    <v-list-item-title>Set payment received in QuickBooks...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetEmailed()"
                >
                    <v-list-item-title>Set emailed...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetCompleteBatch()"
                >
                    <v-list-item-title>Set complete...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </div>
    </div>

    <m-admin-billing-set-complete-dialog
        ref="set-complete-dialog"
        v-on:change="doUpdate"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="2000"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >


        <template v-slot:item.selected="{ item }">
            <v-simple-checkbox
                v-on:input="saveSelected(item)"
                v-model="item.selected"
                :ripple="false"
            />
        </template>

        <template v-slot:item.mrr_state="{ item }">
            <span
                :class="{'flag-mrr-state': flagMRRState(item)}"
            >
                {{item.mrr_state}}
            </span>
        </template>

        <template v-slot:item.organization_state="{ item }">
            <span
                :class="{'flag-mrr-state': flagMRRState(item)}"
            >
                {{item.organization_state}}
            </span>
        </template>

        

        <template v-slot:item.is_complete="{ item }">
            <v-simple-checkbox
                :value="item.is_complete"
                :ripple="false"
                readonly
            />
        </template>

         <template v-slot:item.invoice_emailed="{ item }">
            <v-simple-checkbox
                :value="item.invoice_emailed"
                :ripple="false"
                readonly
            />
        </template>

        <template v-slot:item.intuit_invoice_payment_received="{ item }">
            <v-simple-checkbox
                :value="item.intuit_invoice_payment_received"
                :ripple="false"
                readonly
            />
        </template>

        <template v-slot:item.collection_state="{ item }">
            <v-chip
                :color="getCollectionStateColor(item.collection_state)"
            >
                {{item.collection_state}}
            </v-chip>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickCreateInvoice(item)"
                >
                    <v-list-item-title>Create / update invoice...</v-list-item-title>
                </v-list-item>
                
                <v-divider/>

                <v-list-item
                    v-on:click="onClickUpdateInvoiceAmount(item)"
                >
                    <v-list-item-title>Update invoice amount from quickbooks...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickStripeAutoCollect(item)"
                >
                    <v-list-item-title>Stripe auto collect...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickConnectStripePaymentMethod()"
                >
                    <v-list-item-title>Connect / modify active payment method...</v-list-item-title>
                </v-list-item>

                <v-list-item
                        v-on:click="onClickProvideRedChirpPaymentMethod(item)"
                    >
                        <v-list-item-title>Public link: Provide new payment method...</v-list-item-title>
                    </v-list-item>

                <v-list-item
                    v-on:click="onClickViewCustomerInStripe(item)"
                    :disabled="item.stripe_url_customer == null"
                >
                    <v-list-item-title>View customer in stripe...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickAutoEmailOne(item)"
                    :disabled="item.invoice_emailed == true"
                >
                    <v-list-item-title>Email invoice...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickSetOneCollectionState(item, 'not-collected')"
                    :disabled="item.collection_state == 'not-collected'"
                >
                    <v-list-item-title>Set colleciton state: not-collected</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetOneCollectionState(item, 'success')"
                    :disabled="item.collection_state == 'success'"
                >
                    <v-list-item-title>Set colleciton state: success</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetOneCollectionState(item, 'failed')"
                    :disabled="item.collection_state == 'failed'"
                >
                    <v-list-item-title>Set colleciton state: failed</v-list-item-title>
                </v-list-item>

                 <v-list-item
                    v-on:click="onClickSetOneCollectionState(item, 'void')"
                    :disabled="item.collection_state == 'void'"
                >
                    <v-list-item-title>Set colleciton state: void</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickSetReceviedOneItem(item, true)"
                    :disabled="item.intuit_invoice_payment_received == true"
                >
                    <v-list-item-title>Mark as received</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetReceviedOneItem(item, false)"
                    :disabled="item.intuit_invoice_payment_received == false"
                >
                    <v-list-item-title>Mark as not received</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickSetEmailedOneItem(item, true)"
                    :disabled="item.invoice_emailed == true"
                >
                    <v-list-item-title>Mark as emailed</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetEmailedOneItem(item, false)"
                    :disabled="item.invoice_emailed == false"
                >
                    <v-list-item-title>Mark as not emailed</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickSetComplete(item, true)"
                    :disabled="item.is_complete == true"
                >
                    <v-list-item-title>Mark as complete</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetComplete(item, false)"
                    :disabled="item.is_complete == false"
                >
                    <v-list-item-title>Mark as not complete</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickDraftDeclineEmail(item)"
                >
                    <v-list-item-title>Draft decline email...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>

    
    </v-data-table>

    <div
        style="text-align: right; margin-top: 15px;"
    >
        <v-btn
            class="mx-2" fab dark small color="primary"
            v-on:click="doUpdate"
        >
        <v-icon dark>mdi-refresh</v-icon>
        </v-btn>
    </div>

    <m-admin-billing-batch-operation-dialog
        ref="admin-billing-batch-operation-dialog"
        v-on:close="doUpdate"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            selected_month: null,
            results: [],
            selected: [],
            
            batch: null,
            have_loaded_batch_from_local_storage: false,

            batch_choices: [],

            payment_method: 'any_enum_value',
            collection_state: 'any_enum_value',
            last_invoice: 'any_enum_value',

            last_invoice_choices: [
                { 'text': '(any or none)', 'value': 'any_enum_value' },
                { 'text': 'Blank last invoice amount', 'value': 'first_time' },
                { 'text': 'Non-blank last invoice amount', 'value': 'not_first_time' },
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        onChangeInvoiceMonth()
        {
            this.selected = []; // unselect everything
            this.doUpdate();  
        },
        
        doUpdate()
        {
            let payment_method_filter = this.payment_method;

            if ( payment_method_filter == 'any_enum_value' )
                payment_method_filter = null; 

            let collection_state_filter = this.collection_state;

            if ( collection_state_filter == 'any_enum_value' )
                collection_state_filter = null; 

            let last_invoice_filter = null;

            if ( this.last_invoice == 'first_time' )
            {
                last_invoice_filter = { type: 'is-blank' };
            }
            else if ( this.last_invoice == 'not_first_time' )
            {
                last_invoice_filter = { type: 'is-not-blank' };
            }


            if ( !this.have_loaded_batch_from_local_storage )
            {
                this.have_loaded_batch_from_local_storage = true;

                let from_ls = window.localStorage.getItem('rc_billing_batch');

                if ( from_ls != null )
                    this.batch = parseInt(from_ls);
            } 

            if ( this.selected_month == null ) 
                return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/billing/red-chirp-monthly-invoices',
            
                'params' : {
                        'full_text': this.full_text,
                        'invoice_month': this.selected_month,
                        'batch': this.batch,
                        'payment_method': payment_method_filter,
                        'collection_state': collection_state_filter,
                        'intuit_total_amount_milli_cents_last_month': last_invoice_filter,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                        this.setSelectedInResults();

                        this.batch_choices = [{'text': 'Any Batch', 'value': null}].concat(data.batch_choices);
                    },
            
                'on_error': 'Unable to list invoices',
            });
        },

        onClickCreateMissingInvoices()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/billing/create-missing-monthly-invoices',
            
                'params' : {
                        'invoice_month': this.selected_month,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to create missing invoices',
            });
        },

        saveSelected(item)
        {
            this.selected = this.selected.filter((cur) => { return cur.value != item.invoice_id; });

            if ( item.selected )
            {
                this.selected.push({
                    'text': item.for_organization_label,
                    'value': item.invoice_id
                });
            }
        },

        onClickCloseSelectedChip(item)
        {
            this.selected = this.selected.filter((cur) => { return cur.value != item.value; });

            for ( let i = 0; i < this.results.length; i++ )
            {
                let cur = this.results[i];

                if ( cur.selected && cur.invoice_id == item.value )
                {
                    cur.selected = false;
                }
            }
        },

        isSelected(invoice_id)
        {
            return this.selected.some((cur) => { return cur.value == invoice_id; });
        },

        setSelectedInResults()
        {
            for ( let i = 0; i < this.results.length; i++ )
            {
                this.results[i].selected = this.isSelected(this.results[i].invoice_id);
            }
        },

        onClickSetCompleteBatch()
        {
            this.$refs['set-complete-dialog'].showDialog('complete', this.selected);
        },

        onClickSetEmailed()
        {
            this.$refs['set-complete-dialog'].showDialog('emailed', this.selected);
        },

        onClickSetRecevied()
        {
            this.$refs['set-complete-dialog'].showDialog('received', this.selected);
        },

        onClickSetCollectionState()
        {
            this.$refs['set-complete-dialog'].showDialog('collection', this.selected);
        },

        onClickDraftDeclineEmail(item)
        {
            //alert(JSON.stringify(item.send_invoice_to_customer_emails));
            let payment_url = this.$rc.linkProvideRedChirpPaymentMethod(this.$router, item.for_organization_id);


            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/integrations/gmail/billing-decline',
                'timeout': 120000,
            
                'params' : {
                    'send_invoice_to_customer_emails': item.send_invoice_to_customer_emails,
                    'payment_url': payment_url,
                    },
            
                'on_success': (data) => {
                    
                    if ( data.error_message != null )
                    {
                        this.$rc.alert('Unable to prepare welcome email', data.error_message);
                        return;
                    }


                    this.$rc.alert('Draft welcome email ready','Click <a href="'+data.draft_url+'" target="_blank">here</a> to edit and send the welcome email');
                },
            
                'on_error': 'Unable to prepare draft message',
            });

        },

        onClickSelectAll()
        {
            for ( let i = 0; i < this.results.length; i++ )
            {
                let cur = this.results[i];
                cur.selected = true;

                this.saveSelected(cur);
            }
        },

        onClickClearSelection()
        {
            this.selected = [];
            this.setSelectedInResults();
        },

        getCollectionStateColor(state)
        {
            if ( state == 'not-collected' ) return null;
            if ( state == 'success' ) return 'green lighten-4';
            if ( state == 'failed' ) return 'red lighten-4';
            if ( state == 'void' ) return 'blue lighten-4';
            if ( state == 'exception' ) return 'amber lighten-4';
            if ( state == 'ach-pending' ) return 'green lighten-4';

            return null;
        },

        onClickCreateInvoice(item)
        {
            let url = this.$router.resolve({
                'name': 'admin-billing-one-organization',
                'params' : {
                    'organization_id': item.for_organization_id,
                }
            });

            window.open(url.href, '_blank');
        },

        onClickSetOneCollectionState(item, value)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-collection-state',
            
                'params' : {
                        'invoice_ids': [item.invoice_id],
                        'value': value
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickSetReceviedOneItem(item, value)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-received',
            
                'params' : {
                        'invoice_ids': [item.invoice_id],
                        'value': value
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickSetEmailedOneItem(item, value)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-emailed',
            
                'params' : {
                        'invoice_ids': [item.invoice_id],
                        'value': value
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickSetComplete(item, value)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-complete',
            
                'params' : {
                        'invoice_ids': [item.invoice_id],
                        'value': value
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onChangeBatch()
        {
            window.localStorage.setItem('rc_billing_batch',this.batch);
            this.doUpdate();
        },

        onClickUpdateInvoiceAmount(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'BEFORE-COLLECT: /api/v1/billing/red-chirp-monthly-invoices/stripe-credit-auto-collect/:invoice_id',
                'timeout': 120000,
            
                'params' : {
                        'invoice_id': item.invoice_id,
                    },
            
                'on_success': (data) => {
                       this.doUpdate();
                       this.$rc.snackbar('Updated invoice amount from Quickbooks');
                    },
            
                'on_error': 'Unable to auto collect via stripe',
            });
        },

        onClickStripeAutoCollect(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'BEFORE-COLLECT: /api/v1/billing/red-chirp-monthly-invoices/stripe-credit-auto-collect/:invoice_id',
                'timeout': 120000,
            
                'params' : {
                        'invoice_id': item.invoice_id,
                    },
            
                'on_success': (data) => {
                        
                        if ( !data.ready )
                        {
                            this.$rc.alert('Not ready to auto collect via stripe credit', data.message);
                            return;
                        }

                        this.$rc.confirm({
                            'title': 'Confirm auto charge via stripe credit',
                            'body': 'Organization: '+data.summary.for_organization_label+"<br/><br/>"+data.card_desc+"<br/><br/>Amount: "+data.amount_pretty_print,
                            'btn_text_ok': 'Collect',
                            'btn_text_cancel': 'Cancel',
                            'on_ok': () => {
                                this.doStripeAutoCollect(item);
                            },
                        });

                    },
            
                'on_error': 'Unable to auto collect via stripe',
            });
        },

        doStripeAutoCollect(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'COLLECT: /api/v1/billing/red-chirp-monthly-invoices/stripe-auto-collect/:invoice_id',
                'timeout': 120000,
            
                'params' : {
                        'invoice_id': item.invoice_id,
                    },
            
                'on_success': (data) => {
                        if ( data.success )
                        {
                            this.doUpdate();
                            this.$rc.snackbar('Payment collection started from '+item.for_organization_label);
                            return;
                        }

                        this.$rc.alert('Unable to collect payment', data.message);
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to auto collect via stripe',
            });
        },

        onClickAutoEmailOne(item)
        {
            this.$rc.confirm({
                'title': 'Email invoice',
                'body': 'Email inoice to '+item.send_invoice_to_customer_emails+"?",
                'btn_text_ok': 'Send',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    
                    this.$rc.rest({
                        'spinner': true,
                        'endpoint': 'AUTO-SEND: /api/v1/billing/red-chirp-monthly-invoices/auto-email',
                        'timeout': 60000,
                    
                        'params' : {
                                'invoice_ids': [item.invoice_id],
                            },
                    
                        'on_success': (data) => {
                                this.$rc.snackbar("Email(s) will go out shortly");

                                window.setTimeout(() => {this.doUpdate();}, 2000);
                                window.setTimeout(() => {this.doUpdate();}, 5000);
                                window.setTimeout(() => {this.doUpdate();}, 10000);
                            },
                    
                        'on_error': 'Unable to complete API call',
                    });

                },
            });
        },

        onClickSendEmailSelected()
        {
            let orgs = '';

            for ( let i = 0; i < this.selected.length; i++ )
            {
                orgs += this.selected[i].text;
                orgs += '<br/>';
            }

            this.$rc.confirm({
                'title': 'Send invoice by email',
                'body': 'Send invoice(s) by email for the following organizations:<br/><br/>'+orgs+'<br/>Invoices will not be sent to organizations already marked as having received the invoice by email.',
                'btn_text_ok': 'Send',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.$rc.rest({
                        'spinner': true,
                        'endpoint': 'AUTO-SEND: /api/v1/billing/red-chirp-monthly-invoices/auto-email',
                        'timeout': 60000,
                    
                        'params' : {
                                'invoice_ids': this.selected.map((cur) => { return cur.value; }),
                            },
                    
                        'on_success': (data) => {
                                this.$rc.snackbar("Email(s) will go out shortly");

                                window.setTimeout(() => {this.doUpdate();}, 2000);
                                window.setTimeout(() => {this.doUpdate();}, 5000);
                                window.setTimeout(() => {this.doUpdate();}, 10000);
                            },
                    
                        'on_error': 'Unable to complete API call',
                    });
                },
            });
        },

        onClickExcelExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/billing/red-chirp-monthly-invoices/export',
                    {
                        'invoice_month': this.selected_month,
                    }
                );
        },

        onClickViewCustomerInStripe(item)
        {
            window.open(item.stripe_url_customer, '_blank');
        },

        onClickConnectStripePaymentMethod()
        {
            let url = this.$router.resolve({
                'name': 'admin-redchirp-stripe-search',
                'params' : {
                }
            });

            window.open(url.href, '_blank');
        },

        onClickProvideRedChirpPaymentMethod(item)
        {    
            let url = this.$rc.linkProvideRedChirpPaymentMethod(this.$router, item.for_organization_id);

            this.$rc.copy_dialog({
                    'title': 'Provide new RedChirp payment method: '+item.for_organization_label,
                    'text': 'Provide RedChirp Payment Method URL (public, no sign-in needed)',
                    'value': url,
                });
        },

        onClickUpdateInvoicesBatch()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'UPDATE-INVOICE-BATCH: /api/v1/billing/red-chirp-monthly-invoices',
            
                'params' : {
                        'invoice_ids': this.selected.map((cur) => { return cur.value; }),
                    },
            
                'on_success': (data) => {
                        this.$refs['admin-billing-batch-operation-dialog'].showDialog(data.batch_id);
                    },
            
                'on_error': 'Unable to start batch update invoice',
            });  
        },

        onClickCollectBatch()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'COLLECT-BATCH: /api/v1/billing/red-chirp-monthly-invoices',
            
                'params' : {
                        'invoice_ids': this.selected.map((cur) => { return cur.value; }),
                    },
            
                'on_success': (data) => {
                        this.$refs['admin-billing-batch-operation-dialog'].showDialog(data.batch_id);
                    },
            
                'on_error': 'Unable to start batch collection',
            });  
        },

        flagMRRState(item)
        {
            if ( item.organization_state != 'active' )
                return false;

            return item.mrr_state == 'enrolling' ||
                item.mrr_state == 'trial' ||
                item.mrr_state == 'ready' ||
                item.mrr_state == 'defect-enrolling' ||
                item.mrr_state == 'defect-trial' ||
                item.mrr_state == 'defect-ready' ||
                item.mrr_state == 'canceled';
        }
    },

    computed: {
        headers() {
            let ret = [];
            
            ret.push({ text: '', value: 'selected'});
            ret.push({ text: 'Month', value: 'invoice_month'});
            ret.push({ text: 'Batch', value: 'batch'});
            ret.push({ text: 'Organization', value: 'for_organization_label'});
            ret.push({ text: 'Organization State', value: 'organization_state'});
            ret.push({ text: 'MRR State', value: 'mrr_state'});
            ret.push({ text: 'Invoice Number', value: 'intuit_invoice_number'});
            ret.push({ text: 'Last Invoice Amount', value: 'intuit_invoice_total_amount_last_month_pretty_print'});
            ret.push({ text: 'Invoice Amount', value: 'intuit_invoice_total_amount_pretty_print'});
            ret.push({ text: 'Payment Method', value: 'payment_method'});
            ret.push({ text: 'Email To', value: 'send_invoice_to_customer_emails'});
            ret.push({ text: 'Collection', value: 'collection_state'});
            ret.push({ text: 'Received', value: 'intuit_invoice_payment_received'});
            ret.push({ text: 'Emailed', value: 'invoice_emailed'});
            ret.push({ text: 'Complete', value: 'is_complete'});
            ret.push({ text: 'Action', value: 'action'});

            return ret;
        }
    },

}
</script>

<style lang="scss" scoped>
.flag-mrr-state
{
    font-weight: bold;
    color: red;
}
</style>

